import { Fragment } from 'react';
import { NextLink, Translate, useTranslate } from '~/i18n';
import { AngelLeftIcon, AngelRightIcon } from '~/svgs/common';
import { CardCountsLoader } from '~/components/common/loaders/card';
import VouchersSwiper, { VouchersSwiperLoader } from './vouchers-swiper';

interface SliderSectionProps {
   title?: React.ReactNode;
   subtitle?: React.ReactNode;
   count?: number;
   loading?: boolean;
   id: string;
   content?: any[];
   href?: string;
}

const SliderSection = ({
   loading,
   content,
   title,
   subtitle,
   count,
   id,
   href,
}: SliderSectionProps) => {
   const { dir } = useTranslate();
   return (
      <Fragment>
         <div className="px-1">
            {title && <span className="text-2xl font-bold mb-1">{title}</span>}
            <div className="flex flex-wrap items-center">
               {subtitle && <span className="subheading">{subtitle}</span>}
               <div className="items-center flex">
                  {loading && <CardCountsLoader uniqueKey={id + '-title'} />}
                  {!loading && href && (
                     <NextLink
                        href={href}
                        className="text-primary-color md:ltr:mr-4 md:rtl:ml-4 hover:underline font-bold">
                        <Translate id="common:explore all" values={{ count: count + '' }} />
                     </NextLink>
                  )}
                  <button
                     disabled={loading}
                     className={`swiper-arrow primary ltr:mr-2 rtl:ml-2 ${id}-prev focus:outline-none focus:ring-1 ring-primary-light`}
                     aria-label="previous">
                     {dir === 'rtl' ? <AngelRightIcon /> : <AngelLeftIcon />}
                  </button>
                  <button
                     disabled={loading}
                     className={`swiper-arrow primary ${id}-next focus:outline-none focus:ring-1 ring-primary-light`}
                     aria-label="next">
                     {dir === 'rtl' ? <AngelLeftIcon /> : <AngelRightIcon />}
                  </button>
               </div>
            </div>
         </div>

         <div className="-mx-3=">
            {loading && <VouchersSwiperLoader uniqueKey={id + 'loading'} />}

            {!loading && content && (
               <VouchersSwiper
                  id={`${id + 'swiper'}`}
                  content={content}
                  prevEl={`.${id}-prev`}
                  nextEl={`.${id}-next`}
               />
            )}
         </div>
      </Fragment>
   );
};

export default SliderSection;
